
export type GetApiCoursesCourseIdLecturesLectureIdParams = {
/**
 * 미리보기 모드 (작성자는 수강 신청 없이 접근 가능)
 */
preview?: boolean;
};
